import { Component, HostListener, OnInit } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { RestService } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-cash-register",
  templateUrl: "./cash-register.component.html",
  styles: [],
  standalone: false,
})
export class CashRegisterComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private message: Message,
    private rest: RestService
  ) {}



@HostListener("document:keydown", ["$event"])
    onDocumentKeyDown(event: KeyboardEvent) {
      event.preventDefault();
      if (event.key === "ArrowDown") {
        this.codeAlternativeApi = ''
        this.isArrowDownPressed = true;
      }
    }
  
    @HostListener("document:keyup", ["$event"])
    onDocumentKeyUp(event: KeyboardEvent) {
      event.preventDefault();
      if (event.key === "ArrowDown") {
        this.checkAlternative();
        
      } else {
        if (this.isArrowDownPressed) {
          this.codeAlternativeApi = this.codeAlternativeApi + event.key;
        }
      }
    }

      isArrowDownPressed = false
codeAlternativeApi = ''

  amount: string = "1";
  showCashRegister = false;
  type = "";
  listOfProducts: any[] = [];
  selectedProduct: any;
  servicesToBuy: any[] = [];
  selectedIndexProductToAdd = -1;
  showAdd = false;
  mySalons: any[] = [];
  dataTable: any[] = [];
  mySalon: any;
  showModalDelete = false;
  currentItem: any;
  currentPage = 1;
  totalPages = 1;
  discount = 0;
  userId = -1;
  customers: any = [];
  typeReceipt = -1;

  ngOnInit(): void {
    // this.getReceipt();
    this.getMySalons();
    this.getMyCustomers();
  }

    checkAlternative() {
this.currentPage = 1
    this.getReceipts(this.mySalon)
    this.isArrowDownPressed = false;
  }


  getMyCustomers() {
    this.rest.get("/user/customers?options={%22limit%22:500}").subscribe({
      next: (value: any) => {
        this.customers = value.data.map((client: any) => {
          return {
            label: client.firstName + " " + client.lastName,
            value: client.id,
          };
        });
      },
    });
  }

  changeType(myType: any) {
    this.loader.on();
    let options = { filters: [{ v: this.mySalon.id, s: "salonId", o: null }] };
    let myFunction: any;
    switch (myType) {
      case "service":
        myFunction = this.rest.get(
          `/item/all`
        );
        break;
      case "item":
        myFunction = this.rest.get(
          `/store/all?salonId=${this.mySalon.id}`
        );
        break;
      case "bundle":
        myFunction = this.rest.get(`/bundle/all?salonId=${this.mySalon.id}`);
        break;

      default:
        myFunction = this.rest.get(
          `/receipt/paginate?options=${JSON.stringify(options)}`
        );
        break;
    }
    myFunction.subscribe({
      next: (valueToFix: any) => {
        let value = valueToFix.map((myValue: any) => {
          let newValue = myValue;
          newValue.price = parseFloat((myValue.price ?? 0).toString());
          this.selectedIndexProductToAdd = -1;
          return newValue;
        });
        this.listOfProducts = value;
        this.type = myType;
        this.loader.off(true);
      },
      error: (value: any) => {
        this.loader.off(true);
      },
    });
  }

  changeCustomer(event: any) {
    this.userId = event.value;
  }

  changeTypeReceipt(event: any) {
    this.typeReceipt = event.value;
  }

  getFormattedDate(myDate: Date) {
    const date = new Date(myDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedDate = `${day}/${month}/${year} - ${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}`;
    return formattedDate;
  }

  downloadReceipt(item: any) {
    const ricevutaText = `
                Ricevuta\n
                ------------------------
                ${item.items
                  .map(
                    (myItem: any) =>
                      `${myItem.name} €${myItem.price} x ${myItem.quantity}`
                  )
                  .join("\n")}
                
                \n\nPREZZO INIZIALE: €${item.startPrice}
                \n\nSCONTO: €${item.discount}
                \n\nTOTALE: €${item.total}
            `;
    const pdfText = ricevutaText
      .trim()
      .split("\n")
      .map((line) => `(${line}) Tj 0 -20 Td`)
      .join("\n");
    const pdfData = `%PDF-1.4
            %����
            1 0 obj
            << /Type /Catalog /Pages 2 0 R >>
            endobj
            2 0 obj
            << /Type /Pages /Kids [3 0 R] /Count 1 >>
            endobj
            3 0 obj
            << /Type /Page /Parent 2 0 R /MediaBox [0 0 300 400] /Contents 4 0 R >>
            endobj
            4 0 obj
            << /Length ${pdfText.length + 50} >>
            stream
            BT
            /F1 12 Tf
            50 350 Td
            (Ricevuta di Pagamento) Tj
            0 -20 Td
            ${pdfText}
            ET
            endstream
            endobj
            5 0 obj
            << /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>
            endobj
            xref
            0 6
            0000000000 65535 f 
            0000000010 00000 n 
            0000000050 00000 n 
            0000000110 00000 n 
            0000000170 00000 n 
            0000000240 00000 n 
            trailer
            << /Size 6 /Root 1 0 R >>
            startxref
            290
            %%EOF`;

    const uint8Array = new TextEncoder().encode(pdfData);
    const blob = new Blob([uint8Array], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ricevuta.pdf";
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
  }

  deleteElement(t: any) {
    this.showModalDelete = false;
    this.loader.on();
    this.rest.delete(`/receipt/${this.currentItem.id}`).subscribe({
      next: () => {
        if (this.currentPage >= this.totalPages && this.dataTable.length == 1) {
          this.currentPage = 1;
        }
        this.loader.off(true);
        this.getReceipts(this.mySalon);
      },
      error: () => {
        this.loader.off(true);
        this.message.showMessage(t("errorDelete"), "error");
        this.getReceipts(this.mySalon);
      },
    });
  }

  getReceipts(salon: any) {
    this.loader.on();
    this.mySalon = salon;
    let options = {
      page: this.currentPage,
      filters: [{ v: this.mySalon.id, s: "salonId", o: null }],
    };
    this.rest
      .get(`/receipt/paginate?code=${this.codeAlternativeApi}&options=${JSON.stringify(options)}`)
      .subscribe({
        next: (value: any) => {
          this.dataTable = value.data;
          this.currentPage = value.currentPage;
          this.totalPages = value.totalPages;

          this.loader.off();
        },
        error: (error) => {},
      });
  }

  getMySalons() {
    this.loader.on();
    this.rest.get("/user/me/salon").subscribe({
      next: (value: any) => {
        this.mySalons = value;
        this.loader.off();
      },
      error: (error) => {},
    });
  }

  getTotal() {
    let amount = 0;
    this.servicesToBuy.forEach((service: any) => {
      amount = parseFloat(service.price ?? 0) * service.quantity + amount;
    });
    return amount;
  }

  removeReceiptItem(index: number) {
    this.servicesToBuy.splice(index, 1);
  }

  addProductToList() {
    this.servicesToBuy.push({
      name: this.listOfProducts[this.selectedIndexProductToAdd].name,
      quantity: parseInt(this.amount ?? "0"),
      price: this.listOfProducts[this.selectedIndexProductToAdd]?.price,
      type: this.type,
      typeId: this.listOfProducts[this.selectedIndexProductToAdd]?.id,
    });
  }

  addReceipt() {
    this.loader.on();
    let params = {
      salonId: this.mySalon.id,
      total: this.getTotal(),
      items: this.servicesToBuy,
      userId: this.userId,
      type: this.typeReceipt,
    };
    this.rest.post("/receipt", params).subscribe({
      next: (value) => {
        this.loader.off(true);
        this.showAdd = false;
        this.servicesToBuy = [];
        this.getReceipts(this.mySalon);
        this.typeReceipt = -1;
        this.userId = -1;
        this.listOfProducts = [];
        this.selectedIndexProductToAdd = -1;
        this.type = "";
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  changeProduct(event: any) {
    this.selectedProduct = event;
  }
}
